export default "__VITE_ASSET__D8milOjW__"